import { render } from "./DecorationsVue.vue?vue&type=template&id=6f493efd"
import script from "./DecorationsVue.vue?vue&type=script&lang=js"
export * from "./DecorationsVue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__